import { render, staticRenderFns } from "./SaleAdd.vue?vue&type=template&id=752716c4&scoped=true&"
import script from "./SaleAdd.vue?vue&type=script&lang=js&"
export * from "./SaleAdd.vue?vue&type=script&lang=js&"
import style0 from "./SaleAdd.vue?vue&type=style&index=0&id=752716c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752716c4",
  null
  
)

export default component.exports